import { validatePasswordComplexity } from "@kontextwerk/control-web-frame/logic/passwordPolicy"
import type {
  DemoResetProfileDraft,
  DemoResetProfileOutput,
} from "../../../../../_logic/demo-data-reset-contract"

const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

export type DemoResetProfileValidation = {
  valid: boolean
  errors: {
    accessEmail: string | null
    password: string | null
    contactEmail: string | null
    contactMobile: string | null
  }
}

export const validateDemoResetProfile = (
  draft: DemoResetProfileDraft,
  otherAccessEmail: string | null,
): DemoResetProfileValidation => {
  const accessEmail = draft.accessEmail.trim()
  const contactEmail = draft.contactEmail.trim()
  const contactMobile = draft.contactMobile.trim()
  const password = draft.password
  const errors = {
    accessEmail: !EMAIL_PATTERN.test(accessEmail)
      ? "Bitte geben Sie eine gültige Zugangsmail ein."
      : otherAccessEmail && accessEmail.toLowerCase() === otherAccessEmail.trim().toLowerCase()
        ? "Chef und Geselle benötigen unterschiedliche Zugangsmails."
        : null,
    password:
      password.length > 0
        ? validatePasswordComplexity(password)
        : draft.passwordReusable && draft.reuseUserId
          ? null
          : "Bitte vergeben Sie ein Passwort mit mindestens 12 Zeichen.",
    contactEmail: EMAIL_PATTERN.test(contactEmail)
      ? null
      : "Bitte geben Sie eine gültige Kontaktmail ein.",
    contactMobile: contactMobile ? null : "Bitte geben Sie eine Kontaktmobilnummer ein.",
  }

  return { valid: Object.values(errors).every((error) => error === null), errors }
}

export const buildDemoResetProfileOutput = (
  draft: DemoResetProfileDraft,
  normalizedMobile: string,
): DemoResetProfileOutput => {
  const password = draft.password.length > 0 ? draft.password : null

  return {
    accessEmail: draft.accessEmail.trim(),
    password,
    contactEmail: draft.contactEmail.trim(),
    contactMobile: normalizedMobile,
    reuseUserId: password ? null : draft.reuseUserId,
    passwordMode: password ? "replace" : "reuse",
  }
}
